export const PRINT_TEMPLATE_LOADING = "PRINT_TEMPLATE_LOADING";
export const PRINT_TEMPLATE_RESET = "PRINT_TEMPLATE_RESET";
export const GET_PRINT_TEMPLATE = "GET_PRINT_TEMPLATE";
export const GET_PRINT_TEMPLATE_SUCCESS = "GET_PRINT_TEMPLATE_SUCCESS";
export const GET_PRINT_TEMPLATE_FAIL = "GET_PRINT_TEMPLATE_FAIL";
export const DELETE_PRINT_TEMPLATE = "DELETE_PRINT_TEMPLATE"
export const DELETE_PRINT_TEMPLATE_SUCCESS = "DELETE_PRINT_TEMPLATE_SUCCESS"
export const DELETE_PRINT_TEMPLATE_FAIL = "DELETE_PRINT_TEMPLATE_FAIL"
export const UPDATE_PRINT_TEMPLATE = "UPDATE_PRINT_TEMPLATE"
export const UPDATE_PRINT_TEMPLATE_SUCCESS = "UPDATE_PRINT_TEMPLATE_SUCCESS"
export const UPDATE_PRINT_TEMPLATE_FAIL = "UPDATE_PRINT_TEMPLATE_FAIL"
export const ADD_NEW_PRINT_TEMPLATE = "ADD_NEW_PRINT_TEMPLATE"
export const ADD_PRINT_TEMPLATE_SUCCESS = "ADD_PRINT_TEMPLATE_SUCCESS"
export const ADD_PRINT_TEMPLATE_FAIL = "ADD_PRINT_TEMPLATE_FAIL"